import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileTextIcon, BookIcon, GraduationCapIcon, MessageSquareIcon, BarChart2Icon, ClipboardCheckIcon, PackageIcon, HelpCircleIcon, ArrowRightIcon, SearchIcon, BellIcon, UserIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, ChevronRightIcon } from 'lucide-react';
export function CustomerSupportPage() {
  const navigate = useNavigate();
  // Mock data for recent claims
  const recentClaims = [{
    id: '202534704',
    type: 'Warranty',
    status: 'Approved',
    date: 'Jul 7, 2025',
    dealer: 'AGRO+ SRL'
  }, {
    id: '202528724',
    type: 'Missing part',
    status: 'Pending',
    date: 'Jun 30, 2025',
    dealer: 'ZEPPELIN'
  }, {
    id: '202523188',
    type: 'Warranty',
    status: 'Approved',
    date: 'Jun 27, 2025',
    dealer: 'YUGAGROPOLIV LLC'
  }];
  // Mock data for support metrics
  const supportMetrics = {
    openClaims: 37,
    resolvedClaims: 98,
    avgResponseTime: '3.2 days',
    totalDocuments: 256
  };
  return <div className="min-h-screen bg-gray-100" data-id="element-8087" data-mp="3im9h332j3es5">
      {/* Header */}
      <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 text-white" data-id="element-8088" data-mp="3nkkqxdstppad">
        <div className="container mx-auto px-6 py-8" data-id="element-8089" data-mp="3nmdw0onsg1g9">
          <div className="flex justify-between items-center mb-6" data-id="element-8090" data-mp="3skyy6tmlov7c">
            <h1 className="text-3xl font-bold" data-id="element-8091" data-mp="1dw7e3aocqxn">Customer Support</h1>
            <div className="flex items-center space-x-4" data-id="element-8092" data-mp="1b0bslmauecd">
              <div className="relative" data-id="element-8093" data-mp="2zwb88kqwphng">
                <input type="text" placeholder="Search support resources..." className="pl-10 pr-4 py-2 bg-blue-900/30 border border-blue-800/30 rounded-lg text-white placeholder-blue-300 w-64 focus:outline-none focus:ring-2 focus:ring-blue-500/50" data-id="element-8094" data-mp="2zt5kb8u0kltb" />
                <SearchIcon className="absolute left-3 top-2.5 text-blue-300" size={18} data-id="element-8095" data-mp="3ekxwjbyihjqt" />
              </div>
              <div className="relative" data-id="element-8096" data-mp="2h3peq73h2361">
                <BellIcon size={22} className="text-blue-300 hover:text-white cursor-pointer transition-colors" data-id="element-8097" data-mp="2m3lm8gbdocqc" />
                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-8098" data-mp="2e2md8mhr3jqc">
                  2
                </span>
              </div>
              <div className="bg-blue-800/30 rounded-full w-9 h-9 flex items-center justify-center" data-id="element-8099" data-mp="2nt8m7xuypc02">
                <UserIcon size={20} className="text-white" data-id="element-8100" data-mp="2it2ru9xb5bea" />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-8101" data-mp="1v38hbz0gnyx7">
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-8102" data-mp="1q56ur43tthgz">
              <div className="bg-blue-800/30 p-3 rounded-lg mr-4" data-id="element-8103" data-mp="252hfl42czzpd">
                <ClipboardCheckIcon size={24} className="text-blue-300" data-id="element-8104" data-mp="2034k5uxf9kb6" />
              </div>
              <div data-id="element-8105" data-mp="205h76mi1ekv3">
                <p className="text-blue-300 text-sm" data-id="element-8106" data-mp="3ggv0q15qa11p">Open Claims</p>
                <h3 className="text-3xl font-bold" data-id="element-8107" data-mp="3gjh3zoll5ue4">
                  {supportMetrics.openClaims}
                </h3>
              </div>
            </div>
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-8108" data-mp="3j0rb6ba3927t">
              <div className="bg-teal-800/30 p-3 rounded-lg mr-4" data-id="element-8109" data-mp="3o2gmls183hwf">
                <CheckCircleIcon size={24} className="text-teal-300" data-id="element-8110" data-mp="3a1w8382cc88q" />
              </div>
              <div data-id="element-8111" data-mp="3e26e2kq4uynl">
                <p className="text-blue-300 text-sm" data-id="element-8112" data-mp="3e3hecakddo9y">Resolved Claims</p>
                <h3 className="text-3xl font-bold" data-id="element-8113" data-mp="5me93x52sgyx">
                  {supportMetrics.resolvedClaims}
                </h3>
              </div>
            </div>
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-8114" data-mp="ao3k5csasun0">
              <div className="bg-amber-700/30 p-3 rounded-lg mr-4" data-id="element-8115" data-mp="w67s2pjzwmp">
                <ClockIcon size={24} className="text-amber-300" data-id="element-8116" data-mp="ud2aqqofiga" />
              </div>
              <div data-id="element-8117" data-mp="ok7cf0jm2swu">
                <p className="text-blue-300 text-sm" data-id="element-8118" data-mp="ojnu3iq1u2ia">Avg. Response Time</p>
                <h3 className="text-2xl font-bold" data-id="element-8119" data-mp="te1s7sw3inqn">
                  {supportMetrics.avgResponseTime}
                </h3>
              </div>
            </div>
            <div className="bg-blue-900/20 backdrop-blur-sm rounded-xl p-5 flex items-center border border-blue-800/30" data-id="element-8120" data-mp="2wtxaouep4axj">
              <div className="bg-indigo-800/30 p-3 rounded-lg mr-4" data-id="element-8121" data-mp="2rwex2qpqh7j7">
                <BookIcon size={24} className="text-indigo-300" data-id="element-8122" data-mp="2nu1uuca73rr6" />
              </div>
              <div data-id="element-8123" data-mp="3kk1d4yg5e4my">
                <p className="text-blue-300 text-sm" data-id="element-8124" data-mp="3kkkkjl869amq">Support Documents</p>
                <h3 className="text-3xl font-bold" data-id="element-8125" data-mp="3klvqnrp3auh0">
                  {supportMetrics.totalDocuments}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-6 py-8" data-id="element-8126" data-mp="36t62bgm39dgq">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-8127" data-mp="36se746welhqz">
          {/* Left Column - Support Services */}
          <div className="lg:col-span-2 space-y-8" data-id="element-8128" data-mp="76zdogsugl3l">
            <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-8129" data-mp="2dd7n7h6rfgr">
              Support Services
            </h2>
            {/* Claims Section */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200 hover:shadow-md transition-shadow" data-id="element-8130" data-mp="1l3iu07wm9t5g">
              <div className="p-6 border-b border-gray-100" data-id="element-8131" data-mp="1u1l0v4317g0n">
                <div className="flex items-start" data-id="element-8132" data-mp="1u476gy6d3lg8">
                  <div className="bg-blue-100 p-3 rounded-lg mr-4" data-id="element-8133" data-mp="1z20g616vixl9">
                    <FileTextIcon size={24} className="text-blue-600" data-id="element-8134" data-mp="240ac4e0fa27x" />
                  </div>
                  <div className="flex-1" data-id="element-8135" data-mp="28yvbycbrijvu">
                    <h3 className="text-xl font-bold text-gray-800 mb-1" data-id="element-8136" data-mp="28xtvttfw3779">
                      Claims Management
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-8137" data-mp="2ds7oho363088">
                      Submit and track warranty claims, missing parts, or
                      technical issues
                    </p>
                    <div className="flex flex-wrap gap-3" data-id="element-8138" data-mp="2mooy2mvvuq1v">
                      <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors shadow-sm flex items-center" onClick={() => navigate('/support/claims/new')} data-id="element-8139" data-mp="2rqebuaahphtn">
                        Report New Claim
                      </button>
                      <button className="px-4 py-2 bg-white border border-blue-600 text-blue-600 rounded-lg hover:bg-blue-50 transition-colors shadow-sm flex items-center" onClick={() => navigate('/support/claims/reports')} data-id="element-8140" data-mp="11dom9wqx1h7o">
                        View Claims Reports
                        <ChevronRightIcon size={18} className="ml-1" data-id="element-8141" data-mp="1afphyp6i3v78" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Recent Claims */}
              <div className="bg-gray-50 px-6 py-4" data-id="element-8142" data-mp="1fcfwv96kkkr2">
                <h4 className="text-sm font-medium text-gray-500 mb-3 flex items-center" data-id="element-8143" data-mp="1fdqwqxww98cw">
                  <BarChart2Icon size={16} className="mr-2" data-id="element-8144" data-mp="3m3xedd6br382" />
                  RECENT CLAIMS
                </h4>
                <div className="space-y-2" data-id="element-8145" data-mp="3h6f7rtfs5038">
                  {recentClaims.map(claim => <div key={claim.id} className="flex items-center justify-between bg-white p-3 rounded-lg border border-gray-200" data-id="element-8146" data-mp="1wnl3kb9c85ja">
                      <div className="flex items-center" data-id="element-8147" data-mp="21n7j4rcn1xv9">
                        {claim.status === 'Approved' ? <CheckCircleIcon size={18} className="text-green-500 mr-2" data-id="element-8148" data-mp="1mue0wy5zf3mw" /> : claim.status === 'Pending' ? <ClockIcon size={18} className="text-amber-500 mr-2" data-id="element-8149" data-mp="1rtqqvrs5gqtp" /> : <AlertCircleIcon size={18} className="text-red-500 mr-2" data-id="element-8150" data-mp="1dviubkz0zrj2" />}
                        <div data-id="element-8151" data-mp="1iveokshx84lf">
                          <div className="font-medium text-gray-800" data-id="element-8152" data-mp="1ivn30otozhyq">
                            {claim.id}
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-8153" data-mp="13zz3ve38dl1p">
                            {claim.dealer} • {claim.date}
                          </div>
                        </div>
                      </div>
                      <div data-id="element-8154" data-mp="33aqc63g2y5e8">
                        <span className={`text-xs px-2 py-1 rounded-full ${claim.status === 'Approved' ? 'bg-green-100 text-green-800' : claim.status === 'Pending' ? 'bg-amber-100 text-amber-800' : 'bg-red-100 text-red-800'}`} data-id="element-8155" data-mp="33aytq8n5dyvr">
                          {claim.status}
                        </span>
                      </div>
                    </div>)}
                </div>
                <div className="mt-3 text-center" data-id="element-8156" data-mp="1ccqq8qykbv7m">
                  <button className="text-blue-600 text-sm font-medium hover:text-blue-800 flex items-center mx-auto" onClick={() => navigate('/support/claims/reports')} data-id="element-8157" data-mp="1cbxqwb1xo7zi">
                    View All Claims
                    <ChevronRightIcon size={16} className="ml-1" data-id="element-8158" data-mp="13ahfq13ao1u8" />
                  </button>
                </div>
              </div>
            </div>
            {/* Knowledge Base Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-8159" data-mp="tf61rkzpmynj">
              {/* Aisco Library */}
              <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-teal-900 rounded-xl shadow-sm overflow-hidden text-white hover:shadow-lg transition-shadow border border-blue-800/30" data-id="element-8160" data-mp="2spxp9hl4rpkn">
                <div className="p-6" data-id="element-8161" data-mp="2vavdi3xw5rc6">
                  <div className="flex items-center mb-4" data-id="element-8162" data-mp="309yjbqlp41l7">
                    <div className="bg-blue-800/30 p-3 rounded-lg mr-3" data-id="element-8163" data-mp="308f483brzwl0">
                      <BookIcon size={24} className="text-white" data-id="element-8164" data-mp="351zv7beybqap" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-8165" data-mp="39yzxdb8ok8wj">Aisco | LIBRARY</h3>
                  </div>
                  <p className="mb-6 text-blue-200" data-id="element-8166" data-mp="2cdcdfptevj1w">
                    Access our complete collection of product documentation,
                    technical manuals, catalogs, and brochures in multiple
                    languages.
                  </p>
                  <div className="mt-auto" data-id="element-8167" data-mp="2mcte1stt36r0">
                    <button className="w-full px-4 py-3 bg-blue-800/30 hover:bg-blue-800/50 border border-blue-700/30 rounded-lg transition-colors text-white font-medium flex items-center justify-center" data-id="element-8168" data-mp="2ral6cnyd4uvq">
                      Browse Documentation
                      <ArrowRightIcon size={18} className="ml-2" data-id="element-8169" data-mp="6l5o4hd7mehp" />
                    </button>
                  </div>
                </div>
                <div className="bg-blue-900/50 px-6 py-3 flex justify-between items-center" data-id="element-8170" data-mp="1dbs6ina3o0bn">
                  <span className="text-sm text-blue-200" data-id="element-8171" data-mp="1i30hhnr2vtqx">
                    256 documents available
                  </span>
                  <span className="text-xs bg-blue-800/40 px-2 py-1 rounded-full text-blue-200" data-id="element-8172" data-mp="1n123agfw2763">
                    Updated Weekly
                  </span>
                </div>
              </div>
              {/* Aisco School */}
              <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 rounded-xl shadow-sm overflow-hidden text-white hover:shadow-lg transition-shadow border border-blue-800/30" data-id="element-8173" data-mp="ufiwqc68dvxg">
                <div className="p-6" data-id="element-8174" data-mp="149izi7e1ip30">
                  <div className="flex items-center mb-4" data-id="element-8175" data-mp="2asqwdz0jazo3">
                    <div className="bg-indigo-800/30 p-3 rounded-lg mr-3" data-id="element-8176" data-mp="2aubqxomumily">
                      <GraduationCapIcon size={24} className="text-white" data-id="element-8177" data-mp="2fp7m2xndtm3a" />
                    </div>
                    <h3 className="text-xl font-bold" data-id="element-8178" data-mp="42xbqr9j1ovq">Aisco | SCHOOL</h3>
                  </div>
                  <p className="mb-6 text-blue-200" data-id="element-8179" data-mp="3vas0v06fq4ze">
                    Enhance your technical skills with our expert-led courses.
                    Learn at your own pace and get certified on our irrigation
                    systems.
                  </p>
                  <div className="mt-auto" data-id="element-8180" data-mp="3hivb32s8o766">
                    <button className="w-full px-4 py-3 bg-indigo-800/30 hover:bg-indigo-800/50 border border-indigo-700/30 rounded-lg transition-colors text-white font-medium flex items-center justify-center" data-id="element-8181" data-mp="3hgiky2cbuqi1">
                      Start Learning
                      <ArrowRightIcon size={18} className="ml-2" data-id="element-8182" data-mp="32m4aiq6twpez" />
                    </button>
                  </div>
                </div>
                <div className="bg-indigo-900/50 px-6 py-3 flex justify-between items-center" data-id="element-8183" data-mp="15s9iu3pwviwq">
                  <span className="text-sm text-blue-200" data-id="element-8184" data-mp="10uhf8cfwm8cp">
                    24 courses available
                  </span>
                  <span className="text-xs bg-indigo-800/40 px-2 py-1 rounded-full text-blue-200" data-id="element-8185" data-mp="2v8d68jt5fsw2">
                    Certification Available
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* Right Column - Support Resources */}
          <div className="space-y-8" data-id="element-8186" data-mp="2q90lc4lu8vw4">
            <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-8187" data-mp="3e0616jrs3o6f">
              Support Resources
            </h2>
            {/* Feedback Section */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200 hover:shadow-md transition-shadow" data-id="element-8188" data-mp="3iyzb627uwx1u">
              <div className="p-6" data-id="element-8189" data-mp="391b5wicmk75f">
                <div className="flex items-center mb-4" data-id="element-8190" data-mp="3909uudvlzknp">
                  <div className="bg-purple-100 p-3 rounded-lg mr-3" data-id="element-8191" data-mp="1tl2mkpmmg8jj">
                    <MessageSquareIcon size={24} className="text-purple-600" data-id="element-8192" data-mp="1tmx8a65pw4oo" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-8193" data-mp="1xkbgpvlkq8fm">Feedback</h3>
                </div>
                <p className="text-gray-600 mb-6" data-id="element-8194" data-mp="1q4zrmrbdt7c1">
                  Help us improve Aisco Workspace by sharing your experience and
                  suggestions.
                </p>
                <button className="w-full px-4 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors shadow-sm font-medium" data-id="element-8195" data-mp="200b8pga9iqmy">
                  Submit Feedback
                </button>
              </div>
            </div>
            {/* Quick Support Links */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200" data-id="element-8196" data-mp="12en96miifs77">
              <div className="p-6" data-id="element-8197" data-mp="1h309twsjlz81">
                <h3 className="text-lg font-bold text-gray-800 mb-4" data-id="element-8198" data-mp="1h41o0a4uv1tz">
                  Quick Support
                </h3>
                <div className="space-y-3" data-id="element-8199" data-mp="olnugmqjy20p">
                  <a href="#" className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-8200" data-mp="okcuyz453gfe">
                    <div className="bg-blue-100 p-2 rounded-lg mr-3" data-id="element-8201" data-mp="jl084ed9q9ct">
                      <HelpCircleIcon size={20} className="text-blue-600" data-id="element-8202" data-mp="3j2es4iht1wc8" />
                    </div>
                    <div data-id="element-8203" data-mp="3n2ynphmqcrw9">
                      <div className="font-medium text-gray-800" data-id="element-8204" data-mp="3n02q5ueso58c">FAQ</div>
                      <div className="text-xs text-gray-500" data-id="element-8205" data-mp="3rzyyg5uiyitp">
                        Frequently asked questions
                      </div>
                    </div>
                  </a>
                  <a href="#" className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-8206" data-mp="5l5rcdt4eidu">
                    <div className="bg-green-100 p-2 rounded-lg mr-3" data-id="element-8207" data-mp="an4v3osrvhbb">
                      <PackageIcon size={20} className="text-green-600" data-id="element-8208" data-mp="enx5ilddrs96" />
                    </div>
                    <div data-id="element-8209" data-mp="jkf7jdhbtcht">
                      <div className="font-medium text-gray-800" data-id="element-8210" data-mp="jjm7swgsbn96">
                        Parts Catalog
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-8211" data-mp="2lctjzx13poqu">
                        Browse replacement parts
                      </div>
                    </div>
                  </a>
                  <a href="#" className="flex items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-8212" data-mp="292u76w3qbx9q">
                    <div className="bg-amber-100 p-2 rounded-lg mr-3" data-id="element-8213" data-mp="2437v4pzn0n2i">
                      <ClipboardCheckIcon size={20} className="text-amber-600" data-id="element-8214" data-mp="241eohap0y2ui" />
                    </div>
                    <div data-id="element-8215" data-mp="2wsepdcs26qhy">
                      <div className="font-medium text-gray-800" data-id="element-8216" data-mp="2wsoih98ehdrv">
                        Warranty Information
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-8217" data-mp="2ru4u726c3pwc">
                        Warranty terms and conditions
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            {/* Contact Support */}
            <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 rounded-xl shadow-sm overflow-hidden text-white border border-blue-800/30" data-id="element-8218" data-mp="1bfv689608361">
              <div className="p-6" data-id="element-8219" data-mp="18u49ohemz3u9">
                <h3 className="text-xl font-bold mb-4" data-id="element-8220" data-mp="18v6ymjseew7j">Need Help?</h3>
                <p className="text-blue-200 mb-6" data-id="element-8221" data-mp="1du0cidblkp88">
                  Our support team is available to assist you with any questions
                  or issues.
                </p>
                <div className="space-y-3" data-id="element-8222" data-mp="13vav0lnm56si">
                  <button className="w-full px-4 py-3 bg-white text-gray-900 rounded-lg hover:bg-gray-100 transition-colors font-medium" data-id="element-8223" data-mp="13tzq2iiflszt">
                    Contact Support
                  </button>
                  <button className="w-full px-4 py-3 bg-transparent border border-blue-700/50 text-white rounded-lg hover:bg-blue-800/20 transition-colors" data-id="element-8224" data-mp="uwfo17cqvso5">
                    Schedule a Call
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}